import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshegaoncab() {



    const cardData = {

keyword: "Pune to Shegaon Cab",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Shegaon Cab services for families, devotees, and spiritual travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth long-distance pilgrimage journey. Our service includes doorstep pickup from Pune, flexible one-way and round-trip packages, 24/7 support, and transparent pricing, ensuring a peaceful and hassle-free darshan experience at Shri Gajanan Maharaj Temple in Shegaon.",

topPlaces: [
    {
        title: "Shri Gajanan Maharaj Temple, Shegaon",
        description:
            "Shri Gajanan Maharaj Temple is the most sacred attraction in Shegaon, dedicated to the revered saint Gajanan Maharaj. Devotees from across India visit this temple seeking blessings, peace of mind, and spiritual guidance in a serene and disciplined environment."
    },
    {
        title: "Anand Sagar",
        description:
            "Anand Sagar is a beautifully developed spiritual and recreational complex built by the Shri Gajanan Maharaj Sansthan. It features landscaped gardens, water bodies, meditation zones, and cultural spaces, making it a peaceful retreat for pilgrims and families."
    },
    {
        title: "Gajanan Vatika",
        description:
            "Gajanan Vatika is a serene garden area near the temple complex where devotees can relax and spend quiet time in nature. It is well-maintained and adds to the calm spiritual atmosphere of Shegaon."
    },
    {
        title: "Shegaon Railway Station Temple Area",
        description:
            "The area around Shegaon Railway Station is always active with devotees arriving from across Maharashtra. It has small shrines, food stalls, and accommodations catering to pilgrims visiting the temple."
    },
    {
        title: "Balapur Fort (Nearby)",
        description:
            "Balapur Fort is a historical fort located near Shegaon, known for its ancient architecture and Maratha-era significance. It adds a historical element to the spiritual journey."
    },
    {
        title: "Akola City Temples",
        description:
            "Akola, located near Shegaon, has several old temples and spiritual sites that many pilgrims visit as part of extended devotional trips in the Vidarbha region."
    },
    {
        title: "Sant Gajanan Maharaj Path",
        description:
            "The surrounding devotional routes around Shegaon are filled with pilgrimage activity, chanting devotees, and spiritual stalls, creating a deeply peaceful atmosphere."
    },
    {
        title: "Purna River Region",
        description:
            "The Purna River area near Shegaon offers natural scenic views and calm surroundings, often visited by pilgrims for relaxation during their journey."
    },
    {
        title: "Khamgaon Temple Circuit",
        description:
            "Khamgaon, a nearby town, includes several small temples and spiritual spots that are often included in extended Shegaon pilgrimage itineraries."
    },
    {
        title: "Vidarbha Devotional Route",
        description:
            "The Pune to Shegaon route through Vidarbha is known for its peaceful highways, rural landscapes, and devotional travel atmosphere, making the journey spiritually enriching."
    }
],



services: [
  {
    name: "Pune to Shegaon Cab Service",
    description: "Rising Cab Service offers Pune to Shegaon Cab Service for a safe and comfortable pilgrimage journey to Shri Gajanan Maharaj Sansthan. We provide well-maintained AC Sedan, SUV, Innova Crysta, and Tempo Traveller options with professional drivers, doorstep pickup, and 24x7 support. Ideal for families, devotees, and groups looking for a peaceful and reliable spiritual travel experience."
  },
  {
    name: "Pune to Shegaon Taxi Service",
    description: "Book Pune to Shegaon Taxi Service with Rising Cab Service for smooth and dependable intercity travel. Our experienced drivers ensure safe highway driving, timely pickup, clean vehicles, and comfortable seating for a stress-free pilgrimage to Shegaon."
  },
  {
    name: "Pune to Shegaon Darshan Cab",
    description: "Rising Cab Service provides Pune to Shegaon Darshan Cab for devotees visiting Shri Gajanan Maharaj Temple. Enjoy flexible stops for darshan, comfortable AC rides, and well-planned travel designed for a peaceful spiritual journey."
  },
  {
    name: "Pune to Shegaon Gajanan Maharaj Cab",
    description: "Our Pune to Shegaon Gajanan Maharaj Cab service is specially designed for devotees traveling to Shri Gajanan Maharaj Sansthan. We ensure safe driving, clean vehicles, and reliable service for a smooth pilgrimage experience."
  },
  {
    name: "Pune to Shegaon Cab Booking",
    description: "Rising Cab Service offers instant Pune to Shegaon Cab Booking with multiple vehicle options, easy confirmation, and transparent pricing. Whether one way or round trip, we provide hassle-free booking with 24x7 assistance."
  },
  {
    name: "Pune to Shegaon One Way Cab",
    description: "Our Pune to Shegaon One Way Cab service is ideal for passengers looking for affordable drop-only travel. We offer budget-friendly fares, clean AC vehicles, and professional drivers for a safe long-distance journey."
  },
  {
    name: "Pune to Shegaon Round Trip Cab",
    description: "Rising Cab Service provides Pune to Shegaon Round Trip Cab for same-day or flexible return travel plans. Enjoy comfortable vehicles, safe driving, and waiting time options for family and group pilgrimages."
  },
  {
    name: "Pune to Shegaon Innova Crysta Cab",
    description: "Book Pune to Shegaon Innova Crysta Cab for premium comfort, spacious seating, and smooth highway travel. Ideal for families and groups seeking luxury, safety, and comfort during pilgrimage journeys."
  },
  {
    name: "Pune to Shegaon Sedan Cab Service",
    description: "Our Pune to Shegaon Sedan Cab Service is perfect for small families and budget travelers. We provide clean, AC sedans with professional drivers ensuring safe and comfortable long-distance travel."
  },
  {
    name: "Pune to Shegaon SUV Cab Service",
    description: "Rising Cab Service offers Pune to Shegaon SUV Cab Service for larger families and groups needing extra space and comfort. Our SUVs are well-maintained, AC-enabled, and ideal for smooth pilgrimage travel."
  },
  {
    name: "Pune to Shegaon Pilgrimage Cab",
    description: "Rising Cab Service provides Pune to Shegaon Pilgrimage Cab designed for devotees seeking a peaceful and organized spiritual journey. We ensure flexible travel, safe driving, and comfortable arrangements for darshan."
  },
  {
    name: "Pune to Shegaon Tour Package",
    description: "Book Pune to Shegaon Tour Package with complete travel solutions including cab service, flexible itinerary, and professional drivers for a smooth and comfortable pilgrimage experience."
  },
  {
    name: "Pune to Shegaon Online Cab Booking",
    description: "Rising Cab Service offers easy Pune to Shegaon Online Cab Booking with instant confirmation, multiple cab options, and 24x7 support for a hassle-free travel experience."
  },
  {
    name: "Shegaon Cab from Pune",
    description: "Our Shegaon Cab from Pune service ensures reliable and comfortable travel to Shri Gajanan Maharaj Sansthan with experienced drivers and well-maintained AC vehicles for a safe pilgrimage journey."
  },
  {
    name: "Pune to Shri Gajanan Maharaj Sansthan Cab",
    description: "Rising Cab Service provides Pune to Shri Gajanan Maharaj Sansthan Cab for devotees seeking a direct and comfortable journey. We ensure safe travel, timely pickup, and peaceful pilgrimage experience."
  }
],

tableData: [
  ["Pune to Shegaon Cab Service", "Pune to Shegaon Taxi Service"],
  ["Pune to Shegaon Darshan Cab", "Pune to Shegaon Gajanan Maharaj Cab"],
  ["Pune to Shegaon Cab Booking", "Pune to Shegaon One Way Cab"],
  ["Pune to Shegaon Round Trip Cab", "Pune to Shegaon Innova Crysta Cab"],
  ["Pune to Shegaon Sedan Cab Service", "Pune to Shegaon SUV Cab Service"],
  ["Pune to Shegaon Pilgrimage Cab", "Pune to Shegaon Tour Package"],
  ["Pune to Shegaon Online Cab Booking", "Shegaon Cab from Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Shegaon Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Shegaon cab transportation for devotees, families, senior citizens, tourists, and spiritual travelers visiting the holy town of Shegaon."
    },
    {
        WhyChooseheading: "Convenient Gajanan Maharaj Darshan Travel",
        WhyChoosedescription: "Travel comfortably to Shri Gajanan Maharaj Sansthan, one of Maharashtra's most respected pilgrimage destinations, with well-planned transportation services."
    },
    {
        WhyChooseheading: "Perfect for Religious and Family Tours",
        WhyChoosedescription: "Whether you are planning a spiritual journey, family pilgrimage, group tour, or weekend religious trip, we provide flexible travel solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel requirements and group size."
    },
    {
        WhyChooseheading: "Customized One-Way and Round Trip Packages",
        WhyChoosedescription: "Customers can select one-way travel, return journeys, overnight stays, and customized pilgrimage itineraries according to their schedule."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Safe Long-Distance Travel Experience",
        WhyChoosedescription: "Our experienced drivers ensure smooth highway travel and comfortable journeys for devotees traveling to Shegaon."
    },
    {
        WhyChooseheading: "Ideal for Families and Senior Citizens",
        WhyChoosedescription: "Private cab travel offers flexibility, convenience, and comfort, making it suitable for elderly devotees and family groups."
    }
]
};

const faqData = [
    {
        question: "Why is Shegaon famous among devotees?",
        answer: "Shegaon is renowned for Shri Gajanan Maharaj Sansthan and attracts lakhs of devotees every year from Maharashtra and across India."
    },
    {
        question: "Can I book a one-way cab from Pune to Shegaon?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for family travel to Shegaon?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they offer spacious seating and comfortable travel."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for pilgrimage groups, family tours, and spiritual organizations."
    },
    {
        question: "Can the Anand Sagar project be included in the trip?",
        answer: "Yes, visitors can include Anand Sagar, Gajanan Maharaj Temple, and other local attractions as part of the travel itinerary."
    },
    {
        question: "Do you provide multi-day pilgrimage packages?",
        answer: "Yes, customers can choose overnight stays and customized multi-day pilgrimage plans according to their requirements."
    },
    {
        question: "Can senior citizens travel comfortably on this route?",
        answer: "Yes, private cab transportation provides flexibility and convenience, making it ideal for elderly travelers."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, devotees can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking recommended for Shegaon trips?",
        answer: "Yes, advance reservations are recommended during weekends, holidays, and major religious festivals."
    },
    {
        question: "How can I book a Pune to Shegaon Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sunil Bhagat",
        feedback:
            "Our visit to Gajanan Maharaj Temple was truly memorable. The cab was comfortable, the journey was smooth, and the travel arrangements were handled professionally throughout the trip.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishnavi Deshmukh",
        feedback:
            "Traveling with family to Shegaon became stress-free with Rising Cab Service. We comfortably visited Anand Sagar and the temple, making the pilgrimage a wonderful experience.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Shegaon Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-shegaon-cab.jpg",
"description": "Book Pune to Shegaon Cab Service with Rising Cab Service for safe and comfortable pilgrimage travel to Shri Gajanan Maharaj Temple. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable rates.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-shegaon-cab"
}
};








    return (
        <div>

<Helmet>
  <title>Pune to Shegaon Cab Service | Gajanan Maharaj Darshan Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Shegaon Cab Service for safe and comfortable pilgrimage travel to Shri Gajanan Maharaj Temple. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to shegaon cab, pune to shegaon taxi, cab from pune to shegaon, taxi from pune to shegaon, pune to shegaon cab service, pune to shegaon taxi fare, pune to shegaon one way cab, pune to shegaon round trip taxi, pune to shegaon cab booking, cheap pune to shegaon cab, best pune to shegaon taxi, sedan pune to shegaon cab, suv pune to shegaon cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshegaoncab;